export const tuttoMercatoTheme = `
  --body-bg-color: #f4f4f4;
  --header-bg-golor: #008001;
  --odd-cell-bg-color-highlighted: #d1d1d1;
  --odd-cell-color-highlighted: #20242e;
`;
